'use client'

import { type ReactNode } from 'react'

import { CommandMenuDialog } from '~/components/command-menu/dialog'
import { CommandArgsContext } from '~/components/command-menu/hooks/useCommandArgs'
import { useCommandArgsValue } from '~/components/command-menu/hooks/useCommandArgsValue'
import { CommandMenuContext } from '~/components/command-menu/hooks/useCommandMenu'
import { useCommandMenuState } from '~/components/command-menu/hooks/useCommandMenuState'
import { CommandMenuHotkeys } from '~/components/command-menu/hotkeys'

export const CommandMenuProvider = ({ children }: { children: ReactNode }) => {
  const {
    menuContext,
    activeView,
    pathname,
    address,
    setActiveView,
    isEnabled,
  } = useCommandMenuState()

  const commandArgsValue = useCommandArgsValue({
    activeView,
    pathname,
    address,
    setActiveView,
  })

  return (
    <CommandMenuContext value={menuContext}>
      <CommandArgsContext value={commandArgsValue}>
        {isEnabled && (
          <>
            <CommandMenuDialog />
            <CommandMenuHotkeys />
          </>
        )}
        {children}
      </CommandArgsContext>
    </CommandMenuContext>
  )
}

export { useCommandMenu } from './hooks/useCommandMenu'
